import React, { Fragment, useState } from "react";
import * as Icon from "react-feather";
import { useSelector, useDispatch } from "react-redux";
import { Nav, NavLink, NavItem, Collapse } from "reactstrap";
import { useLocation, Link, useNavigate } from "react-router-dom";
import SimpleBar from "simplebar-react";
// import SidebarData from '../sidebardata/SidebarData';
// import SidebarDistributor from '../sidebardata/DistributorSidebarData';
// import SuperDistributorData from '../sidebardata/SPDistributorData';
import HorizontalSidebarData from "../sidebardata/HorizontalSidebarData";
import NavItemContainer from "./NavItemContainer";
import NavSubMenu from "./NavSubMenu";
import Logo from "../../../assets/images/logos/logo.png";
import { logout } from "../../../slices/authSlice/userSilce";
import { Modal } from "antd";
import { ToggleMobileSidebar } from "../../../store/customizer/CustomizerSlice";

/* eslint-disable */

const Sidebar = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const currentURL = location.pathname.split("/").slice(0, -1).join("/");
  const { user: currentUser } = useSelector((state) => state.user);
  const activeBg = useSelector((state) => state.customizer.sidebarBg);
  const isFixed = useSelector((state) => state.customizer.isSidebarFixed);
  const [activeSubMenu, setActiveSubMenu] = useState(null);

  const [collapseState, setCollapseState] = useState({
    reports: false,
    settings: false,
    wallets: false,
    payouts: false,
    mydetails: false,
    supports: false,
    disReports: false,
  });

  const toggleCollapse = (menu) => {
    setCollapseState((prev) => ({
      reports: menu === "reports" ? !prev.reports : false,
      disReports: menu === "disReports" ? !prev.disReports : false,
      superDisReports:
        menu === "superDisReports" ? !prev.superDisReports : false,
      settings: menu === "settings" ? !prev.settings : false,
      wallets: menu === "wallets" ? !prev.wallets : false,
      payouts: menu === "payouts" ? !prev.payouts : false,
      mydetails: menu === "mydetails" ? !prev.mydetails : false,
      supports: menu === "supports" ? !prev.supports : false,
    }));
  };

  const handleNavLinkClick = () => {
    dispatch(ToggleMobileSidebar());
  };

  const handleLogoutClick = () => {
    Modal.confirm({
      title: "Logout",
      content: "Are you sure to Logout?",
      onCancel() {},
      onOk() {
        window.addEventListener("beforeunload", () => {
          dispatch(logout());
        });
        navigate("/login", { replace: true });
        window.location.reload();
      },
    });
  };

  const renderDashboardLogo = () => {
    const logos = {
      1: "/Dashboards/AdminDashboard",
      2: "/Dashboards/AdminDashboard",
      4: "/Dashboards/SuperDistributorDashboard",
      5: "/Dashboards/DistributorDashboard",
      60: "/Dashboards/RetailerDashboard",
    };
    const href = logos[currentUser.role];
    return href ? (
      <Link to={href} className="role-logo">
        <img src={Logo} alt="profile" />
      </Link>
    ) : null;
  };

  const generateNavItems = (items) =>
    items.map((item) => (
      <NavItem
        key={item.title}
        className={`hide-mini ${
          location.pathname === item.href ? "activeLink" : ""
        }`}
      >
        <NavLink
          tag={Link}
          to={item.href}
          onClick={handleNavLinkClick}
          className="gap-2"
        >
          <span className="sidebarIcon">{item.icon}</span>
          <span className="hide-mini">
            <span>{item.title}</span>
          </span>
        </NavLink>
      </NavItem>
    ));

  const menuConfig = {
    wallets: [
      { title: "QR Code", href: "/Agent/QRCode", icon: <Icon.ChevronRight /> },
    ],

    reports: [
      // { title: "Account Status Report", href: "/Agent/AccountStatusReports", icon: <Icon.ChevronRight />},
      {
        title: "Ledger Reports",
        href: "/Agent/LedgerReport",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Money Transfer Reports",
        href: "/Agent/DMTTransactionReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "AEPS Ledger Reports",
        href: "/Agent/AEPSLedgerReport",
        icon: <Icon.ChevronRight />,
        id: 13.1,
        collapisble: false,
      },
      {
        title: "Cashout Reports",
        href: "/Agent/CashoutTransaction",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "DMT Transaction Search By Account / Sender Mobile",
        href: "/Agent/GetTransactionByAccountNumber",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Transaction search by consumer number",
        href: "/Agent/GetTransactionByConsumerNo",
        icon: <Icon.ChevronRight />,
      },
      // { title: "Mony Transfer Hold Case Reports", href: "/Agent/MoneyTransferHoldCases", icon: <Icon.ChevronRight />},
      {
        title: "AEPS Transaction Reports",
        href: "/Agent/AEPSTransactionReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Utility Payment Report",
        href: "/Agent/BBPSPaymentsReports",
        icon: <Icon.ChevronRight />,
      },
      // {
      //   title: "PaymentsGetway Reports",
      //   href: "/Agent/PaymentGetwayReports",
      //   icon: <Icon.ChevronRight />,
      // },
      {
        title: "OutStanding Reports",
        href: "/Agent/OutStandingReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Credit Card Reports",
        href: "/Agent/CreditCardReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "CMS Reports",
        href: "/Agent/CMSReport",
        icon: <Icon.ChevronRight />,
      },
      // {
      //   title: "GST Reports",
      //   href: "/Agent/GSTReports",
      //   icon: <Icon.ChevronRight />,
      // },
      // {
      //   title: "TDS Reports",
      //   href: "/Agent/TDSReports",
      //   icon: <Icon.ChevronRight />,
      // },
      {
        title: "TopUp Reports",
        href: "/Agent/TopUpReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Refund Report",
        href: "/Agent/RefundReports",
        icon: <Icon.ChevronRight />,
      },
      // {
      //   title: "Check Status By Txn Id",
      //   href: "/Agent/AdminChangeStatus",
      //   icon: <Icon.ChevronRight />,
      // },
    ],

    disReports: [
      {
        title: "Ledger",
        href: "/dashboards/LedgerReportDistributor",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Money Transfer Reports",
        href: "/dashboards/DistributorDMTTransactionReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "AEPS Transection Reports",
        href: "/dashboards/DistributorAEPSTransactionReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Direct TopUp Report",
        href: "/Distributor/DirectTopUpReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Money Transfer Hold",
        href: "/dashboards/DistributorMoneyTransferHoldCases",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "AEPS Ledger Reports",
        href: "/dashboards/DistributorAEPSLedgerReport",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Business Reports",
        href: "/Distributor/DistributorBusinessReport",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Outstanding Reports",
        href: "/Distributor/DistributorOutStandingReports",
        icon: <Icon.ChevronRight />,
      },
      // { title: "Commission Report", href: "/dashboards/CommisionReportDistributor", icon: <Icon.ChevronRight />},
    ],

    superDisReports: [
      {
        title: "Ledger",
        href: "/dashboards/LedgerSuperReportDistributor",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Money Transfer Reports",
        href: "/dashboards/SuperDistributorDMTTransactionReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "AEPS Transection Reports",
        href: "/dashboards/SuperDistributorAEPSTransactionReports",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Money Transfer Hold",
        href: "/dashboards/SuperDistributorMoneyTransferHoldCases",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "AEPS Ledger Reports",
        href: "/dashboards/SuperDistributorAEPSLedgerReport",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Business Reports",
        href: "/SuperDistributor/SuperDistributorBusinessReport",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Outstanding Reports",
        href: "/SuperDistributor/SuperDistributorOutStandingReports",
        icon: <Icon.ChevronRight />,
      },
      // { title: "Commission Report", href: "/dashboards/CommisionReportDistributor", icon: <Icon.ChevronRight />},
      {
        title: "Direct TopUp Report",
        href: "/SuperDistributor/DirectTopUpReport",
        icon: <Icon.ChevronRight />,
      },
    ],

    payouts: [
      {
        title: "OrbitRemit",
        href: "/Agent/SearchPayoutCustomer",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Move To Bank",
        href: "/Agent/AEPSPayout",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "AEPS To Main Wallet",
        href: "/Agent/AEPSToDMTTransfer",
        icon: <Icon.ChevronRight />,
      },
    ],

    mydetails: [
      {
        title: "Change TPIN",
        href: "/Agent/SetTPIN",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Reset TPIN",
        href: "/Agent/ResetTPIN",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Raise Complaint",
        href: "/Agent/ComplaintListAgent",
        icon: <Icon.ChevronRight />,
      },
      {
        title: "Raise Bill Payment Complaint",
        href: "/Agent/ComplaintListAgentBillAvenue",
        icon: <Icon.ChevronRight />,
        id: 12.2,
        collapisble: false,
      },
    ],
  };

  const renderCollapsibleMenu = (key, icon, label) => (
    <NavItem className={collapseState[key] ? "activeParent" : ""}>
      <NavLink
        className="cursor-pointer gap-2"
        onClick={() => toggleCollapse(key)}
      >
        <span className="sidebarIcon d-flex align-items-center">{icon}</span>
        <span className="hide-mini w-100">
          <div className="d-flex align-items-center">
            <span className="d-block">{label}</span>
            <span className="ms-auto">
              <i
                className={`bi fs-8 ${
                  collapseState[key] ? "bi-chevron-down" : "bi-chevron-right"
                }`}
              />
            </span>
          </div>
        </span>
      </NavLink>
      <Collapse isOpen={collapseState[key]} navbar tag="ul" className="subMenu">
        {generateNavItems(menuConfig[key])}
      </Collapse>
    </NavItem>
  );

  return (
    <div className={`sidebarBox   ${isFixed ? "fixedSidebar" : ""}`}>
      <SimpleBar style={{ height: "100%" }}>
        {renderDashboardLogo()}

        <div className="mb-4 pb-5 mt-1" loading={loading}>
          <Nav vertical className={activeBg === "white" ? "" : "lightText"}>
            {currentUser.role === "6" && currentUser.kycStatus ? (
              <Fragment>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Dashboards/RetailerDashboard"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Home />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Dashboard</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/SelfBank/RetailorBankList"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      {/* <Icon.User /> */}
                      <Icon.Minimize2 />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Agent Self Bank</span>
                    </span>
                  </NavLink>
                </NavItem>

                {renderCollapsibleMenu(
                  "wallets",
                  // <Icon.Power />,
                  <i class="bi fs-4 bi-wallet2"></i>,
                  "Wallet Update"
                )}

                {renderCollapsibleMenu(
                  "payouts",
                  <Icon.Airplay />,
                  "AEPS Wallet"
                )}

                {renderCollapsibleMenu(
                  "reports",
                  // <Icon.PhoneCall />,
                  <Icon.Clipboard />,
                  "Agent Reports"
                )}

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Agent/BalanceRequestHistory"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      {/* <Icon.DollarSign /> */}
                      <span className="fs-4 fw-light">₹</span>
                      {/* <i class="bi bi-currency-rupee"></i> */}
                    </span>
                    <span className="hide-mini w-100">
                      <span>Balance Request</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Agent/MonthlyInvoice"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Calendar />
                      {/* <span className="fs-4 fw-light">₹</span>
                      <i class="bi bi-currency-rupee"></i> */}
                    </span>
                    <span className="hide-mini w-100">
                      <span>Monthly Invoice</span>
                    </span>
                  </NavLink>
                </NavItem>

                {renderCollapsibleMenu(
                  "mydetails",
                  // <Icon.Settings />,
                  <Icon.User />,
                  "My Details"
                )}

                <NavItem>
                  <NavLink onClick={handleLogoutClick} className="gap-2">
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.LogOut />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Logout</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
              </Fragment>
            ) : currentUser.role === "5" && currentUser.kycStatus ? (
              <Fragment>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Dashboards/DistributorDashboard"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Home />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Dashboard</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/ViewRetailerDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UserPlus />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Add Agent</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/ManageCreditDebitDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Clipboard />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Manage Credit/Debit</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/CreditDetailsDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Clipboard />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Credit Details</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/WalletToWalletTransferDistributorReport"
                    className="gap-2"
                    onClick={handleNavLinkClick}
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.CreditCard />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Wallet to Wallet</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/MonthlyInvoice"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Calendar />
                      {/* <span className="fs-4 fw-light">₹</span>
                      <i class="bi bi-currency-rupee"></i> */}
                    </span>
                    <span className="hide-mini w-100">
                      <span>Monthly Invoice</span>
                    </span>
                  </NavLink>
                </NavItem>

                {renderCollapsibleMenu("disReports", <Icon.List />, "Reports")}

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/DistributorBankList"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UploadCloud />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Self Bank Master</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Distributor/BalanceRequestHistoryDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Send />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Balance Request</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  {/* <NavLink tag={Link} to="/Distributor/TransactionReportAgent" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink tag={Link} to="#" className="gap-2 d-none">
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.List />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Agent Trans Details</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
              </Fragment>
            ) : currentUser.role === "4" && currentUser.kycStatus ? (
              <Fragment>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Dashboards/SuperDistributorDashboard"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Home />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Dashboard</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/dashboards/SuperViewRetailerDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UserPlus />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Add Distributor</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/dashboards/SuperViewRetailer"
                    className="gap-2"
                    onClick={handleNavLinkClick}
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UserPlus />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Add Retailer</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/dashboards/SuperManageCreditDebitDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Clipboard />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Manage Credit/Debit</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/dashboards/SuperCreditDetailsDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.CreditCard />
                    </span>
                    <span className="hide-mini w-100">
                      <span>Credit Details</span>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Super/WalletToWalletTransferSuperDistributorReport"
                    className="gap-2"
                    onClick={handleNavLinkClick}
                    {...menuConfig}
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      {/* <Icon.Activity color={dashboardMenuColor} /> */}
                      <Icon.Activity />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Wallet to Wallet</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/SuperDistributor/MonthlyInvoice"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Calendar />
                      {/* <span className="fs-4 fw-light">₹</span>
                      <i class="bi bi-currency-rupee"></i> */}
                    </span>
                    <span className="hide-mini w-100">
                      <span>Monthly Invoice</span>
                    </span>
                  </NavLink>
                </NavItem>

                {renderCollapsibleMenu(
                  "superDisReports",
                  <Icon.List />,
                  "Reports"
                )}

                <NavItem>
                  {/* <NavLink tag={Link} to="/Reports/SPCommissionReport" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/dashboards/CommisionSuperReportDistributor"
                    className="gap-2 d-none"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.List />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Commission Report</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  {/* <NavLink tag={Link} to="/Bank/SPDistributorBankList" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/SuperDistributor/SPDistributorBankList"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UploadCloud />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Self Bank Master</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  {/* <NavLink tag={Link} to="/Funds/FundRequestSuperDistributor" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/SuperDistributor/BalanceRequestHistorySuper"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Send />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Balance Request</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
              </Fragment>
            ) : currentUser.role === "3" && currentUser.kycStatus ? (
              <Fragment>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/Dashboards/MasterDistributorDashboard"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Home />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Dashboard</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/dashboards/MasterViewSuperDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UserPlus />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Add Super Distributor</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/dashboards/MasterManageCreditDebitDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Clipboard />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Manage Credit/Debit</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  <NavLink
                    tag={Link}
                    to="/MasterDistributor/MasterCreditDetails"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Clipboard />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Credit Details</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  {/* <NavLink tag={Link} to="/Reports/SPLedgerReports" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/dashboards/LedgerMasterReportDistributor"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.List />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Ledger Details</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  {/* <NavLink tag={Link} to="/Reports/SPCommissionReport" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/dashboards/CommisionSuperReportDistributor"
                    className="gap-2 d-none"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.List />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Commission Report</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  {/* <NavLink tag={Link} to="/SuperDistributor/ChangePasswordSP" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/MasterDistributor/ChangePasswordMd"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Settings />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Change Password</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
                <NavItem>
                  {/* <NavLink tag={Link} to="/Bank/SPDistributorBankList" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/MasterDistributor/MasterBankList"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.UploadCloud />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Self Bank Master</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>

                <NavItem>
                  {/* <NavLink tag={Link} to="/Funds/FundRequestSuperDistributor" onClick={handleNavLinkClick} className="gap-2"> */}
                  <NavLink
                    tag={Link}
                    to="/MasterDistributor/BalanceRequestHistoryMaster"
                    onClick={handleNavLinkClick}
                    className="gap-2"
                  >
                    <span className="sidebarIcon d-flex align-items-center">
                      <Icon.Send />
                    </span>
                    <span className="hide-mini w-100">
                      <div className="d-flex align-items-center">
                        <span>Balance Request</span>
                      </div>
                    </span>
                  </NavLink>
                </NavItem>
              </Fragment>
            ) : currentUser.role === "1" ? (
              <Fragment>
                {HorizontalSidebarData.map((navi) => {
                  if (navi.caption) {
                    return (
                      <div
                        className="navCaption text-uppercase mt-4"
                        key={navi.caption}
                      >
                        {navi.caption}
                      </div>
                    );
                  }
                  if (navi.children) {
                    return (
                      <NavSubMenu
                        key={navi.id}
                        icon={navi.icon}
                        title={navi.title}
                        items={navi.children}
                        suffix={navi.suffix}
                        suffixColor={navi.suffixColor}
                        mobNavClose={() => handleNavLinkClick(navi.id)}
                        isUrl={currentURL === navi.href}
                        isOpen={activeSubMenu === navi.id}
                        onToggle={() =>
                          setActiveSubMenu((prev) =>
                            prev === navi.id ? null : navi.id
                          )
                        }
                      />
                    );
                  }
                  return (
                    <NavItemContainer
                      key={navi.id}
                      mobNavClose={() => handleNavLinkClick(navi.id)}
                      className={
                        location.pathname === navi.href ? "activeLink" : ""
                      }
                      to={navi.href}
                      title={navi.title}
                      suffix={navi.suffix}
                      suffixColor={navi.suffixColor}
                      icon={navi.icon}
                    />
                  );
                })}
              </Fragment>
            ) : (
              <h3
                className="text-warning fw-bold"
                style={{ marginLeft: "1.7rem" }}
              >
                User KYC is Pending
              </h3>
            )}
          </Nav>
        </div>
      </SimpleBar>
    </div>
  );
};

export default Sidebar;
